import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';
import { Select } from '@ngxs/store';
import { AuthState } from '../../../store/state/auth.state';
import { Observable } from 'rxjs';
import { IUser } from '../../../interfaces/users/user.interface';
import { featuresWithPermissions } from '../../../data/permissions';

@Component({
    selector: 'app-admin-data',
    templateUrl: './admin-data.component.html',
    styleUrls: ['./admin-data.component.scss'],
})
export class AdminDataComponent {
    @Select(AuthState.currentUser) public currentUser$: Observable<IUser>;

    @Input() public formGroup: FormGroup;
    @Input() public isEdit: boolean;

    @Output() public elementSizeModification = new EventEmitter<void>();

    public basicInputTypeEnum = BasicInputTypeEnum;

    public permissions = featuresWithPermissions;

    public get firstname(): FormControl {
        return this.formGroup.get('firstname') as FormControl;
    }

    public get lastname(): FormControl {
        return this.formGroup.get('lastname') as FormControl;
    }

    public get isActive(): FormControl {
        return this.formGroup.get('isActive') as FormControl;
    }

    public get email(): FormControl {
        return this.formGroup.get('email') as FormControl;
    }
}
